import React from "react";
import { Sidebar } from "primereact/sidebar";
import { Typography } from "@material-ui/core";
const SideBarLayout = ({
  title,
  visible,
  position,
  minWidthPercent = "50%",
  children,
  onHide,
}) => {
  if (typeof position === "undefined") {
    position = "left";
  }
  return (
    <Sidebar
      visible={visible}
      position={position}
      style={{ width: `${minWidthPercent}` }}
      onHide={onHide}
      showCloseIcon={false}
      icons={() => (
        <React.Fragment>
          <Typography variant="h6" className="kt-font-bolder">
            {title}
          </Typography>
          <div className="kt-sidebar-panel__close" onClick={onHide}>
            <i className="flaticon2-delete" />
          </div>
        </React.Fragment>
      )}
    >
      {children}
    </Sidebar>
  );
};

export default SideBarLayout;
